import { useRef } from 'react'
import { hasCalled } from './calledScreen'
import { LayoutSurface, type LayoutBindings } from './render'
import type { LayoutDocument } from './types'

/** The call a Called screen draws. */
export interface ShownCall {
  number: string
  desk: string
  deskNumber?: string
  service?: string
}

/** The Called screen's bindings: the board's, with the call in the ticket's and desk's places. */
export function calledBindings(bindings: LayoutBindings, call: ShownCall | null): LayoutBindings {
  return {
    ...bindings,
    ticketNumber: call?.number ?? '',
    deskName: call?.desk ?? '',
    deskNumber: call?.deskNumber ?? '',
    serviceName: call?.service ?? '',
  }
}

/**
 * A main display: its board, and over it the Called screen while a call shows. The
 * board stays mounted underneath, so its lists and playlists carry on. The Called
 * layer is mounted from the start, its pictures and fonts loaded before the first call,
 * and keeps the last call while it fades out.
 */
export function DisplayStage({
  document: doc,
  bindings,
  call,
}: {
  document: LayoutDocument
  bindings: LayoutBindings
  call: ShownCall | null
}) {
  const last = useRef<ShownCall | null>(null)
  if (call) last.current = call
  return (
    <>
      <LayoutSurface document={doc} screen="board" bindings={bindings} />
      {hasCalled(doc) && (
        <div className="board-called" data-on={call ? true : undefined} aria-hidden={!call}>
          <LayoutSurface document={doc} screen="call" bindings={calledBindings(bindings, last.current)} />
        </div>
      )}
    </>
  )
}
